export default {
  // START:: GET APP LOCALE
  getAppLocale(state) {
    return state.Tard_provider_dashboard_language;
  },
  // END:: GET APP LOCALE
};
